module.exports = __webpack_public_path__ + "img/ic_peakpower.aa625e12.svg";